import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";
import ConceptSection from "./components/ConceptSection";
import DejeunerSection from "./components/DejeunerSection";
import DinerSection from "./components/DinerSection";
import BarSection from "./components/BarSection";
import CarteSection from "./components/CarteSection";
import VIPSection from "./components/VIPSection";
import GallerySection from "./components/GallerySection";
import ReservationSection from "./components/ReservationSection";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ConceptSection />
        <DejeunerSection />
        <DinerSection />
        <BarSection />
        <CarteSection />
        <VIPSection />
        <GallerySection />
        <ReservationSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
